






























































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseStepper",
  props: {
    steps: { type: Number, required: true },
    current: { type: Number },
    loading: { type: Boolean, default: false },
    safeMode: { type: Boolean, default: false },
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    hasNext(): boolean {
      return this.currentStep < this.steps;
    },

    hasPrev(): boolean {
      return this.currentStep > 1;
    },
  },
  watch: {
    current(current: number) {
      this.next(current);
    },
  },
  methods: {
    next(step?: number) {
      if (typeof step !== "number") step = undefined;
      if (step || this.hasNext) this.currentStep = step ? step : this.currentStep + 1;
    },

    prev() {
      if (this.hasPrev) this.currentStep = this.currentStep - 1;
    },
  },
});
